// extracted by mini-css-extract-plugin
export var grid = "styles-module--grid--PpoDY";
export var gridSection = "styles-module--gridSection--DjBul";
export var sectionHeading = "styles-module--sectionHeading--UcvrY";
export var selectSliceButtons = "styles-module--selectSliceButtons--PcNdx";
export var title = "styles-module--title--QoENV";